import { useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "../Nav/nav";
import Footer from "../Footer/footer";
import Contact from "./contact";

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Nav />
      <main id="main">
        {/* Breadcrumbs */}
        <section className="breadcrumbs">
          <div className="container">
            <ol>
              <li><Link to="/">Home</Link></li>
              <li>Contact Us</li>
            </ol>
            <h2>Get in Touch with SDtech Solutions</h2>
          </div>
        </section>

        {/* Contact Form / Info */}
        <Contact />

        {/* 📍 Map Section */}
        <section className="map-section" style={{ padding: "60px 0", background: "#f8f9fa" }}>
          <div className="container">
            <div className="section-header text-center mb-4">
              <h3 style={{ fontWeight: "700", marginBottom: "10px" }}>Our Location</h3>
              <p style={{ color: "#666", maxWidth: "600px", margin: "0 auto" }}>
                Visit us at our office or find us on the map below. We're always happy to meet in person!
              </p>
            </div>

            <div
              className="map-wrapper"
              style={{
                position: "relative",
                width: "100%",
                aspectRatio: "16 / 9",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                background: "#e9ecef"
              }}
            >
              <iframe
                // 🔗 REPLACE THIS SRC WITH YOUR ACTUAL GOOGLE MAPS EMBED URL
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.3260044558274!2d75.76503412610566!3d22.716121179389827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x420572e9588fe00f%3A0x2a2c589ce0260e7a!2sSDtech%20Solutions!5e0!3m2!1sen!2sin!4v1782393655218!5m2!1sen!2sin"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SDtech Solutions Office Location"
              ></iframe>
            </div>
          </div>
        </section>
      </main>
      {/* <Footer /> */}
    </>
  );
}

